import React, {useState, useEffect} from 'react';
import { fetchDailyData } from '../../api';
import { Line, Bar } from 'react-chartjs-2';

import styles from './Chart.module.css';
const  Chart = ({ data, country, countryData }) =>{
    const [dailyData, setDailyData] = useState([]); 
    
    useEffect(()=>{
        const fetchAPI = async() => {
            setDailyData(await fetchDailyData());
        }
        fetchAPI();
    },[]);
    const lineChartConfirmed = (
        dailyData.length
        ?(
            <Line
            data={{
                labels: dailyData.map(({ date }) => date),
                datasets: [{
                    data: dailyData.map(({ confirmed }) => confirmed),
                    label: 'Infected',
                    borderColor: "#3333ff",
                    fill: true,
                }],
                }}
                options={{
                    title: {display: true, text: "Daily Cases"}
                }}
            />) : null
        
    );
    const lineChartDeath = (
        
        dailyData.length
        ?(
            <Line
            data={{
                
                labels: dailyData.map(({ date }) => date),
                datasets: [{
                    data: dailyData.map(({ deaths }) => deaths),
                    label: 'Deaths',
                    borderColor: "red",
                    backgroundColor: 'rgba(255, 0, 0, 0.5)',
                    fill: true,
                }],
                }}
                options={{
                    title: {display: true, text: "Daily Deaths"}
                }}
            />) : null
        
    );
  
    const countryLineChartConfirmed = (
        countryData.length
        ?(
            <Line
            data={{
                labels: countryData.map(({ date }) => new Date(date).toDateString()),
                datasets: [{
                    data: countryData.map(({ confirmed }) => confirmed),
                    label: 'Infected',
                    borderColor: "#3333ff",
                    fill: true,
                }],
                }}
                options={{
                    title: {display: true, text: "Daily Cases in "+country}
                }}
            />) : null
        
    );  

    const countryLineChartDeath = (
        countryData.length
        ?(
            <Line
            data={{
                labels: countryData.map(({ date }) => new Date(date).toDateString()),
                datasets: [{
                    data: countryData.map(({ deaths }) => deaths),
                    label: 'Deaths',
                    borderColor: "red",
                    backgroundColor: 'rgba(255, 0, 0, 0.5)',
                    fill: true,
                }],
                }}
                options={{
                    title: {display: true, text: "Daily Deaths in "+country}
                }}
            />) : null
        
    );
    
    const countryLineChartRecovered = (
        countryData.length
        ?(
            <Line
            data={{
                labels: countryData.map(({ date }) => new Date(date).toDateString()),
                datasets: [{
                    data: countryData.map(({ recovered }) => recovered),
                    label: 'Recovered',
                    borderColor: "green",
                    backgroundColor: 'rgba(0, 255, 0, 0.5)',
                    fill: true,
                }],
                }}
                options={{
                    title: {display: true, text: "Daily Recoveries in "+country}
                }}
            />) : null
        
    );

    const countryLineChartActive = (
        countryData.length
        ?(
            <Line
            data={{
                labels: countryData.map(({ date }) => new Date(date).toDateString()),
                datasets: [{
                    data: countryData.map(({ active }) => active),
                    label: 'Active Cases',
                    borderColor: "#33eeff",
                    fill: true,
                }],
                }}
                options={{
                    title: {display: true, text: "Daily Active Cases in "+country}
                }}
            />) : null
        
    );


    const countryLineChartVersus = (
        countryData.length
        ?(
            <Line
            data={{
                labels: countryData.map(({ date }) => new Date(date).toDateString()),
                datasets: [{
                    data: countryData.map(({ recovered }) => recovered),
                    label: 'Recovered',
                    borderColor: "green",
                    backgroundColor: 'rgba(0, 255, 0, 0.5)',
                    fill: true,
                },{
                    data: countryData.map(({ deaths }) => deaths),
                    label: 'deaths',
                    borderColor: "red",
                    backgroundColor: 'rgba(255, 0, 0, 0.5)',
                    fill: true,
                },{
                    data: countryData.map(({ confirmed }) => confirmed),
                    label: 'Infected',
                    borderColor: "#3333ff",
                    fill: true,
                }],
                }}
                options={{
                    title: {display: true, text: "Daily states in "+country}
                }}
            />) : null
        
    );

    const lineChartVersus = (
        dailyData.length
        ?(
            <Line
            data={{
                labels: dailyData.map(({ date }) => new Date(date).toDateString()),
                datasets: [{
                    data: dailyData.map(({ deaths }) => deaths),
                    label: 'deaths',
                    borderColor: "red",
                    backgroundColor: 'rgba(255, 0, 0, 0.5)',
                    fill: true,
                },{
                    data: dailyData.map(({ confirmed }) => confirmed),
                    label: 'Infected',
                    borderColor: "#3333ff",
                    fill: true,
                }],
                }}
                options={{
                    title: {display: true, text: "Daily states"}
                }}
            />) : null
        
    );
    const barChart = (
        data.Global
        ?(
            <Bar
                
                data={{
                    labels: ['Infected', 'Recovered', 'Deaths'],
                    datasets: [{
                        label: 'People',
                        backgroundColor: [
                            'rgba(0, 0, 255, 0.5)',
                            'rgba(0, 255, 0, 0.5)',
                            'rgba(255, 0, 0, 0.5)',
                        ],
                        data:[data.Global.TotalConfirmed, data.Global.TotalRecovered, data.Global.TotalDeaths]
                    }]
                }}
                options={{
                    legend: {display: false},
                    title: {display: true, text: "Current state"}
                }}
            />
        ) : null
    )

    const countryBarChart = (
        countryData.length
        ?(
            <Bar
                
                data={{
                    labels: ['Infected', 'Recovered', 'Deaths', 'Active'],
                    datasets: [{
                        label: 'People',
                        backgroundColor: [
                            'rgba(0, 0, 255, 0.5)',
                            'rgba(0, 255, 0, 0.5)',
                            'rgba(255, 0, 0, 0.5)',
                            '#33eeff'
                        ],
                        data:[countryData[countryData.length - 1].confirmed, countryData[countryData.length - 1].recovered, countryData[countryData.length - 1].deaths, countryData[countryData.length - 1].active]
                    }]
                }}
                options={{
                    legend: {display: false},
                    title: {display: true, text: "Current state in "+country}
                }}
            />
        ) : null
    )
    
    return(
        <div className={styles.container}>
            <div className={styles.charts}>
                {country ? countryLineChartVersus : lineChartVersus}
            </div>
            <div className={styles.charts}>
                {country ? countryLineChartConfirmed : lineChartConfirmed}
            </div>
            <div className={styles.charts}>
                {country ? countryLineChartDeath : lineChartDeath}
            </div>
            <div className={styles.charts}>
                {country ? countryLineChartRecovered : ""}
            </div>
            <div className={styles.charts}>
                {country ? countryLineChartActive : ""}
            </div>
            <div className={styles.charts}>
                {country ? countryBarChart : barChart}
            </div>
            
            
            
            
        </div>
    )
}

export default Chart;